/**
 * What the MO grid draws, and therefore what its export writes (§5.9).
 * Its own module so the grid and the export cannot hide different columns.
 */

import {
  exportColumns,
  groupedColumns,
  type ExportColumn,
} from '@/components/report/groupedColumns';
import type { ReportColumn } from '@/lib/api';

/** Hidden: the per-exception 0/1 flags that drive the cards are of no use as columns. */
export function isHiddenMoColumn(column: ReportColumn): boolean {
  return column.field.startsWith('exception_');
}

/** The MO layout for the export request, built through the grid's own {@link groupedColumns} call. */
export function moExportColumns(columns: readonly ReportColumn[]): ExportColumn[] {
  return exportColumns(
    groupedColumns<Record<string, unknown>>([...columns], { hide: isHiddenMoColumn }),
  );
}
